import { CuraButtonOutline, CuraIcon, CuraParagraph } from '@rededor/cura-react'

import { useIsActiveBreakPoint } from '@/hooks/useIsActiveBreakPoint'
import { Bold } from '@/shared/styles/styled-elements'
import * as S from './styles'

export const Button = () => {
  const isMobile = useIsActiveBreakPoint('medium')
  return (
    <CuraButtonOutline
      size="small"
      style={{
        marginTop: isMobile ? '36px' : '24px',
        maxHeight: '48px',
        width: '100%'
      }}
      color="primary"
      justify={true}
      href={isMobile ? 'tel:3003-3230' : undefined}
    >
      <S.ContainerButton>
        <CuraParagraph size="xsmall" marginBlock="0" color="primary-darker">
          <Bold $weight="bold">
            CENTRAL DE ATENDIMENTO
            <br />
            3003-3230
          </Bold>
        </CuraParagraph>
        <CuraIcon name="phone" size={20} color="primary-darker" />
      </S.ContainerButton>
    </CuraButtonOutline>
  )
}
